<div class="flex-center user-display-logo" [style.width.px]="size" [style.height.px]="size"
  [style.background-color]="background" [style.color]="color">
  @if (!user || (user && account.email !== account.firstName && account.email !== account.lastName)) {
    <span class="fw-500" [style.font-size.px]="fontSize ? fontSize : (size / 2) - 2">{{!user ? 'K.' : (account.firstName.charAt(0).toUpperCase() + account.lastName.charAt(0).toUpperCase())}}</span>
  }
  @if (user && (account.email === account.firstName || account.email === account.lastName)) {
    <span class="fw-500" [style.font-size.px]="fontSize ? fontSize : (size / 2) - 2">{{account.email.charAt(0).toUpperCase() + account.email.charAt(1).toUpperCase()}}</span>
  }
</div>
